import { render, staticRenderFns } from "./EtfRelateFund.vue?vue&type=template&id=2ea582a6&scoped=true&"
import script from "./EtfRelateFund.vue?vue&type=script&lang=js&"
export * from "./EtfRelateFund.vue?vue&type=script&lang=js&"
import style0 from "./EtfRelateFund.vue?vue&type=style&index=0&id=2ea582a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea582a6",
  null
  
)

export default component.exports